import { IconButton } from "@mui/material";
import styled from "styled-components";

export const StyledAdVariantPreview = styled.div`
  width: 100%;
`;

export const StyledAdVariantListCard = styled.div`
  /* width: 281.69px; */
  width: 100%;
  min-width: 335px;
  min-height: 450px;
  height: 100%;
  padding-bottom: -50px;
  overflow-y: scroll;
  /* background: #ffffff; */
  /* border-radius: 10px; */
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  .holder {
    background: red;
    padding: 20px;
    height: 20px;
  }
`;

export const StyledMainCreativeHead = styled.div`
  background: #f2f2f2;
  border: 1px solid #dadcde;
  border-radius: 10px 10px 0px 0px;
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root {
    padding: 0px;
  }
`;
export const StyledMainCreativeImage = styled.img`
  height: 85%;
  width: 100%;
  object-fit: fill;
`;

export const StyledAdVariantListButton = styled(IconButton)`
  width: 30px !important;
  height: 30px !important;
  background: #f8f8f8 !important;
  border-radius: 9px !important;
  font-size: 12px !important;
`;

export const StyledVariantItemPara = styled.p`
  margin-bottom: 0px;
  font-size: 14px;
  color: #333333;
  font-weight: 400;
  max-lines: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 15rem;
  font-family: Inter;
`;
export const StyledHeading4New = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 15rem;
  font-family: "Inter";
`;

export const StyledAdVariantBottomBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 281.69px;
  margin-top: 8px;
`;

export const StyledFrameHolder = styled.div`
  position: relative;
  z-index: 9999999999999999999999999999999;
  background-color: #fff;
  width: 370px;
  max-width: 500px;
  display: flex;
  align-items: center;
  overflow-y: scroll;
  min-height: 450px;
  height: 100%;
  /* border-radius: 20px; */
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;
export const StyledFrame = styled.iframe`
  z-index: 9999;
  width: 370px;
  max-width: 500px;
  min-height: 450px;
`;
